import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import {
  Flag,
  FlagDivider,
} from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const HeadlineLink = styled(EntityLink)`
  display: block;

  color: #000000;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 1.4;

  &:hover {
    text-decoration: underline;
  }

  h2 {
    margin: 0;
  }

  ${Flag} {
    color: #727272;
    font-style: italic;
  }

  ${FlagDivider} {
    font-style: normal;
  }
`;

export const Timestamp = styled.div`
  margin-block-start: 8px;

  color: #727272;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: normal;
`;

export const CoverLink = styled(EntityLink)`
  display: block;

  overflow: hidden;
  aspect-ratio: 3 / 2;
`;

export const InlineCover = styled.div`
  margin-block-start: 4px;
  margin-block-start: 12px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

type ContainerProps = {
  $isLead?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;

  ${props =>
    props.$isLead &&
    css`
      ${HeadlineLink} {
        font-size: 17px;
      }
    `}

  :not(:first-of-type) {
    margin-block-start: 16px;
    padding-block-start: 12px;
    border-block-start: 1px #dfdfdf solid;
  }

  ${theme.breakpoints.up("tablet")} {
    :not(:first-of-type) {
      margin-block-start: 12px;
      padding-block-start: 12px;
      border-block-start: 1px #dfdfdf solid;
    }
  }
`;
